// extracted by mini-css-extract-plugin
module.exports = {"root":"SendReceipts_root__2gcGN","buttons":"SendReceipts_buttons__B0de0","email":"SendReceipts_email__2Zia0","bookApptTitle":"SendReceipts_bookApptTitle__2KYf_"};